import {
  RiCheckLine,
  RiSendPlaneLine,
  RiFlightTakeoffFill,
  RiForbidFill,
} from '@remixicon/react';

export const formatUSPhone = (phone) => {
  if (!phone) return '';
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 10) return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  if (digits.length === 11 && digits[0] === '1') return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  return phone;
};

export const STATUS_CONFIG = {
  ACCEPTED: { label: 'Confirmed', icon: RiCheckLine, color: 'text-blue-600 bg-blue-50 border-blue-200' },
  SENT: { label: 'Quote Sent', icon: RiSendPlaneLine, color: 'text-blue-600 bg-blue-50 border-blue-200' },
  IN_TRANSIT: { label: 'In-Flight', icon: RiFlightTakeoffFill, color: 'text-green-400 bg-green-50 border-green-50' },
  INACTIVE: { label: 'Inactive', icon: RiForbidFill, color: 'text-gray-500 bg-gray-50 border-gray-200' },
};
